
import React, { createContext, useContext, useMemo, useState } from 'react';
import { apiURL } from 'config';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { setLoading } from 'redux/actions/app';
import axios from 'axios';
import moment from 'moment';
import { store } from 'react-notifications-component';
import * as API from 'services/api';
import { RemoveModal } from 'components';
import FileUploadModal from 'components/FileUploadModal';

export default function useHomeContext() {
    const context = useContext(HomeContext);
    if (!context) {
        throw new Error('useHomeContext must be used within a HomeProvider');
    }
    return context;
}

const HomeContext = createContext();

export const HomeProvider = ({ children }) => {
    const dispatch = useDispatch();
    const onDirectDownload = ({ ged, title, documentDate, productId, type }) => async e => {
        dispatch(setLoading(true));
        await axios({ url: `${apiURL}documents/Documents?ged=${ged}`, method: 'GET', responseType: 'blob' })
            .then((response) => {
                dispatch(setLoading(false));
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', productId ? `${type}_${moment(documentDate).format('DDMMYYYY')}_${productId}.pdf` : `${title}.pdf`);
                document.body.appendChild(link);
                link.click();
            }).catch(err => {
                console.log(err)
                dispatch(setLoading(false));
                window.open(`${apiURL}documents/Documents?ged=${ged}`, "_blank");
            });
    }

    const onDownload = (ged) => e => {
        const newWindow = window.open(`${apiURL}documents/Documents?ged=${ged}`, "_blank");
        setTimeout(function () {
            try {
                newWindow.document.title = "Documents";
            } catch (err) {
                console.log(err);
            }
        }, 100);
    }

    const onDiscoverFile = (ged, link) => {
        if (ged) {
            window.open(`${apiURL}documents/Documents?ged=${ged}`, "_blank");
        } else if (link) {
            window.open(link, "_blank");
        }
    }

    const onDownloadFile = async file => {
        const url = file.ged ? `${apiURL}documents/Documents?ged=${file.ged}` : file.privateUrl;
        let filename = file.title + ".pdf"
        if (!file.ged) {
            const splitnames = file.Key.split("/")
            filename = splitnames[splitnames.length - 1]
        }
        dispatch(setLoading(true));
        await axios({ url: url, method: 'GET', responseType: 'blob' })
            .then((response) => {
                dispatch(setLoading(false));
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
            }).catch(err => {
                console.log(err)
                dispatch(setLoading(false));
                window.open(url);
            });
    };

    const [importUsersModalVisible, setImportUsersModalVisible] = useState(false);

    const [duplicated, setDuplicated] = useState();

    const toggleUsersImportModal = () => {
        setImportUsersModalVisible(false);
    };
    const onImportTrainees = (file, type, forced) => {
        setDuplicated();
        dispatch(setLoading(true));
        const formData = new FormData();
        formData.append('type', type);
        formData.append('file', file);
        if (forced)
            formData.append('forced', forced);

        API.importTraines(formData)
            .then(res => {
                dispatch(setLoading(false));
                if (res.code === 201) {
                    setDuplicated({ file, type });
                    return;
                } else if (res.code === 200) {
                    toggleUsersImportModal();
                    store.addNotification({
                        message: "uploaded successfully.",
                        type: 'success',
                        container: 'top-right',
                        animationIn: ['animated', 'fadeIn'],
                        animationOut: ['animated', 'fadeOut'],
                        dismiss: {
                            duration: 5000,
                            onScreen: true,
                        },
                    });
                } else {
                    store.addNotification({
                        message: res.message,
                        type: 'danger',
                        container: 'top-right',
                        animationIn: ['animated', 'fadeIn'],
                        animationOut: ['animated', 'fadeOut'],
                        dismiss: {
                            duration: 5000,
                            onScreen: true,
                        },
                    });
                }
            })
            .catch(err => {
                console.log(err)
                dispatch(setLoading(false));
            });
    };

    const values = useMemo(() => ({
        onDirectDownload,
        onDownload,
        onDiscoverFile,
        onDownloadFile,

        setImportUsersModalVisible
    }), [

    ]);
    return (
        <HomeContext.Provider
            value={values}
        >
            {children}
            <FileUploadModal
                addFree={true}
                visible={importUsersModalVisible}
                onConfirm={onImportTrainees}
                onClose={toggleUsersImportModal}
            />
            {duplicated && (
                <RemoveModal
                    visible={!!duplicated}
                    onClose={() => setDuplicated()}
                    onConfirm={() => {
                        onImportTrainees(duplicated.file, duplicated.type, true)
                    }}
                    loading={false}
                    title="Confirm"
                    description={"Cette session semble avoir déjà été importée, souhaitez vous continuer ?"}
                />
            )}
        </HomeContext.Provider>
    );
};

HomeProvider.propTypes = {
    children: PropTypes.any,
};